import { Navigate } from 'react-router-dom';

import { useAuth } from '../features/auth/core/useAuth';

/*
 * The root page renders no content of its own (a general dashboard
 * may live here one day): with a valid session it goes straight to
 * the dashboard, without one to the login — which in Keycloak mode
 * immediately forwards to the identity provider.
 */
export const LandingPage = () => {
  const { isAuthenticated, isLoading } = useAuth();

  /* while the session is being restored (e.g. a token renewal),
     render nothing — redirecting now would be premature */
  if (isLoading) return null;

  if (isAuthenticated) return <Navigate to="/dashboard" replace />;

  return <Navigate to="/login" state={{ returnTo: '/dashboard' }} replace />;
};
